import styled from 'styled-components'

export const GoTopContainer = styled.div`
  position: relative;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    padding: 0 16px;
  }

  .GlobalGoTop__content {
    position: relative;
    width: 1200px;
    height: 0;
    margin: 0 auto;
    z-index: 5;
    text-align: right;

    .GlobalGoTop__imgWrapper {
      cursor: pointer;
      transform: translateY(-50%);
    }

    ${({ theme }) => theme.breakpoints.down('sm')} {
      width: 100%;
    }
  }
`
